import cx from 'classnames';
import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import styles from './MarkdownRenderer.module.scss';

export const MarkdownRenderer = ({ content }: { content: string }) => {
    return (
        <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            children={content}
            components={{
                h1({ node: _, children, ...props }) {
                    return (
                        <h1 className={styles.h1} {...props}>
                            {children}
                        </h1>
                    );
                },
                h2({ node: _, children, ...props }) {
                    return (
                        <h2 className={styles.h2} {...props}>
                            {children}
                        </h2>
                    );
                },
                h3({ node: _, children, ...props }) {
                    return (
                        <h3 className={styles.h3} {...props}>
                            {children}
                        </h3>
                    );
                },
                p({ node: _, ...props }) {
                    return <p className={styles.p} {...props} />;
                },
                ul({ node: _, className, ...props }) {
                    return <ul className={cx(styles.ul, className)} {...props} />;
                },
                li({ node: _, className, children, ...props }) {
                    return (
                        <li className={cx(styles.li, className)} {...props}>
                            <span className={styles.liContent}>{children}</span>
                        </li>
                    );
                },
                blockquote({ node: _, className, ...props }) {
                    return <blockquote className={cx(styles.blockquote, className)} {...props} />;
                },
                table({ node: _, className, ...props }) {
                    return <table className={cx(styles.table, className)} {...props} />;
                },
                img({ node: _, className, ...props }) {
                    return <img className={cx(styles.img, className)} {...props} alt="" />;
                },
                ol({ node: _, className, ...props }) {
                    return <ol className={cx(styles.ol, className)} {...props} />;
                },
                dl({ node: _, className, ...props }) {
                    return <dl className={cx(styles.dl, className)} {...props} />;
                },
                dt({ node: _, className, ...props }) {
                    return <dt className={cx(styles.dt, className)} {...props} />;
                },
                dd({ node: _, className, ...props }) {
                    return <dd className={cx(styles.dd, className)} {...props} />;
                },
                a({ node: _, className, children, ...props }) {
                    return (
                        <a className={cx(styles.a, className)} {...props}>
                            {children}
                        </a>
                    );
                },
                hr({ node: _, className, ...props }) {
                    return <hr className={cx(styles.hr, className)} {...props} />;
                },
                input({ node: _, className, ...props }) {
                    return <input className={cx(styles.input, className)} {...props} disabled={false} />;
                },
                strong({ node: _, className, ...props }) {
                    return <span className={cx(styles.strong, className)} {...props} />;
                },
            }}
        />
    );
};
